export default {
  name: "Home",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M29.69 14.28 17.36 2.53c-.76-.7-1.95-.7-2.72.01L2.31 14.28c-.65.58-.19 1.75.69 1.72h2v11c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2v-5h4v5c0 1.1.9 2 2 2h5a2 2 0 0 0 2-2V16h2c.88.03 1.34-1.14.69-1.72zM15.99 3.99 26.5 14h-21L15.99 3.99zM25 27h-5v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H7V16h18v11z",
  },
}
